import SkapaText, { TextProps } from '@ingka/text';
import styled from 'styled-components';

type TTextProps = {
  $marginBottom?: boolean;
};

type AllTextProps = TTextProps & TextProps;

export const Text = styled(SkapaText)<AllTextProps>`
  margin-block-end: ${props => {
    return props.$marginBottom ? '1rem' : '';
  }};
`;

export const Title = styled(Text)`
  margin-block-end: 1.5rem;
`;
